import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiServerService } from 'app/shared/services/api-server.service';
import { switchMap, map, catchError, of } from 'rxjs';
import { AccountOrganizationActions } from '../actions/account-organization.actions';
import { AccountOrganization } from '@smmof/entity';

@Injectable()
export class AccountOrganizationEffects {
  constructor(private actions$: Actions, private apiService: ApiServerService) {}

  loadOrganizations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountOrganizationActions.loadOrganizations),
      switchMap(() =>
        this.apiService.GET<AccountOrganization[]>('account-organizations').pipe(
          map((organizations) =>
            AccountOrganizationActions.loadOrganizationsSuccess({ organizations })
          ),
          catchError((error) =>
            of(AccountOrganizationActions.loadOrganizationsFailure({ error }))
          )
        )
      )
    )
  );

  createOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountOrganizationActions.createOrganization),
      switchMap(({ organization }) =>
        this.apiService.POST<AccountOrganization>(
          'account-organizations',
          organization
        ).pipe(
          map((newOrganization) =>
            AccountOrganizationActions.createOrganizationSuccess({ organization: newOrganization })
          ),
          catchError((error) =>
            of(AccountOrganizationActions.createOrganizationFailure({ error }))
          )
        )
      )
    )
  );
}
